import React, { useMemo } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useField, useFormikContext } from 'formik';
import { TextField, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  // To override the global SAS styles
  clearIndicator: {
    '&.MuiAutocomplete-clearIndicator': {
      minHeight: 'unset',
      minWidth: 'unset',
    },
  },
  // To override the global SAS styles
  popupIndicator: {
    '&.MuiAutocomplete-popupIndicator': {
      minHeight: 'unset',
      minWidth: 'unset',
    },
  },
}));

function TransitAirportsField({
  name,
  label,
  disabled,
  noOptionsText,
  onBlur,
  data,
  ...props
}) {
  const classes = useStyles();
  const { setFieldValue, isSubmitting } = useFormikContext();
  const [field, meta] = useField(name);

  const fieldError = meta.error;
  const showError = !!fieldError;

  const airports = useMemo(() => {
    if (data) {
      const airportsArr = data.reduce((output, country) => {
        country.cities.map((city) => {
          if (city && city.airports) {
            city.airports.map(({ code, name }) => {
              output.push({
                code,
                title: `${city.name}, ${country.code} (${code} - ${name})`,
              });
            });
          }
        });
        return output;
      }, []);
      return airportsArr;
    }
  }, [data]);

  if (!airports) {
    return null;
  }

  return (
    <Autocomplete
      multiple
      fullWidth
      options={airports}
      noOptionsText={noOptionsText ?? noOptionsText}
      limitTags={5}
      autoHighlight
      clearOnBlur
      value={field.value}
      disabled={isSubmitting}
      onChange={(e, newValue) => setFieldValue(name, newValue)}
      getOptionLabel={(option) => option.title}
      renderInput={(params) => {
        return (
          <TextField
            fullWidth
            type="text"
            variant="outlined"
            name={name}
            label={label}
            autoComplete="new-password"
            helperText={showError ? fieldError : ''}
            error={showError}
            disabled={disabled ?? isSubmitting}
            inputProps={{
              autoComplete: 'new-password',
            }}
            {...props}
            {...params}
          />
        );
      }}
      {...props}
      classes={{
        clearIndicator: classes.clearIndicator,
        popupIndicator: classes.popupIndicator,
      }}
    />
  );
}

TransitAirportsField.propTypes = {};

export default TransitAirportsField;
